<template>
  <div>
    <deleteModal
      :show="delete_exportation"
      title="Delete exportation"
      :text="`Are you sure you want to delete this exportation ( ${itemToDelete ? itemToDelete.export_name : ''} ) ?`"
      :callback="() => deleteExportation(itemToDelete ? itemToDelete.id : '')"
    />
    <v-data-table
      :headers="headers"
      :items="data.items"
      :options.sync="pagination"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
      :server-items-length="data.count"
      :loading="loading"
      :items-per-page="10"
    >
      <!-- modal to confrim the export refresh -->

      <template v-slot:item.status="{ item }">
        <badge
          :text="item.status == 'done' ? 'success' : item.status"
          :color="item.status == 'done' ? 'success' : 'secondary'"
          :progress="item.status == 'pending'"
        />
      </template>
      <template v-slot:item.schedule="{ item }">
        <template v-if="item.schedule && item.schedule.enabled">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-chip small color="primary" label v-bind="attrs" v-on="on">
                <v-icon small left>mdi-calendar-sync</v-icon>
                Daily
              </v-chip>
            </template>
            <span>This export runs automatically every day</span>
          </v-tooltip>
        </template>
        <span v-else class="text--disabled text-caption">—</span>
      </template>
      <template v-slot:item.action="{ item }">
        <v-menu bottom left offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" small color="grey">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item @click="downloadFile(item.id)" :disabled="item.status != 'done'">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-download</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Download File</v-list-item-title>
            </v-list-item>

            <v-list-item @click="refreshDownload(item.id)">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-refresh</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Re-export</v-list-item-title>
            </v-list-item>

            <v-list-item
              @click="setItemToDelete(item)"
              :disabled="item.status != 'done' || isViewer"
            >
              <v-list-item-icon class="mr-2">
                <v-icon small :color="item.status != 'done' || isViewer ? 'grey' : 'error'"
                  >mdi-delete</v-icon
                >
              </v-list-item-icon>
              <v-list-item-title
                :class="item.status != 'done' || isViewer ? 'grey--text' : 'error--text'"
                >Delete exportation</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>
<script>
  import axios from 'axios'
  import io from 'socket.io-client'

  export default {
    computed: {
      isViewer() {
        return this.$store.getters.userRole === 'viewer'
      },
    },
    data: () => ({
      delete_exportation: false,
      deleting: null,
      itemToDelete: null,
      data: [],
      loading: false,
      pagination: { rowsPerPage: 10, totalItems: 0 },
      headers: [
        { text: 'File name', value: 'filename', sortable: false },
        { text: 'Name', value: 'export_name', sortable: false },
        { text: 'Date', value: 'date', align: 'center', sortable: false },
        {
          text: 'Status',
          value: 'status',
          align: 'center',
          sortable: false,
          width: '1%',
        },
        {
          text: 'Schedule',
          value: 'schedule',
          align: 'center',
          sortable: false,
          width: '1%',
        },
        { text: 'Action', value: 'action', align: 'center', sortable: false },
      ],
    }),
    props: ['exportations', 'component_name'],
    components: {},
    mounted() {
      this.data = this.exportations
      this.pagination.totalItems = this.data.count
      this.$socket.client.on('globalListener', (data) => {
        if (data.dataChanged && data.cause == 'exportationChanges') {
          this.getRequests()
        }
      })
      this.start()
    },
    methods: {
      blobToFile(data, filename) {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        link.remove()
      },
      setItemToDelete(item) {
        if (this.isViewer) return
        this.itemToDelete = item
        this.delete_exportation = !this.delete_exportation
      },
      setDeleteExportation(val) {
        console.log('val : ', val)
        if (!val) {
          this.delete_exportation = false
          this.itemToDelete = null
          console.log('this.delete_exportation : ', this.delete_exportation)
        }
      },
      deleteExportation(id) {
        this.loading = true
        this.data = []
        this.delete_exportation = !this.delete_exportation
        axios
          .post('/api/exportation/delete', {
            id,
          })

          .then((res) => {
            this.$emit('showNotification', {
              type: 'success',
              msg: 'Exportation deleted',
            })
          })
          .catch((err) => {
            this.$emit('showNotification', {
              type: 'error',
              msg: 'Exportation deletion failed',
            })
          })
          .finally(() => {
            setTimeout(() => {
              this.getRequests()
              this.loading = false
            }, 1000)
          })
      },
      // TODO : add a confirmation dialog before deleting the exportation
      refreshDownload(id) {
        console.log('re-exporting this id : ', id)
        console.log('this.data : ', this.data)
        const refreshedItem = this.data.items.find((item) => item.id == id)
        refreshedItem.status = 'pending'
        axios
          .post('/api/exportation/refreshexport', {
            id,
          })
          .then((res) => {
            this.$emit('showNotification', {
              type: 'success',
              msg: 'Re-exportation started',
            })
          })
          .catch((err) => {
            this.$emit('showNotification', {
              type: 'error',
              msg: 'Re-exportation failed',
            })
          })
      },
      downloadFile(id) {
        axios
          .get('/api/exportation/getfile', {
            params: {
              account: localStorage.getItem('account_id'),
              user: localStorage.getItem('user_id'),
              component: this.component_name,
              id,
            },
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            responseType: 'blob',
          })
          .then((res) => {
            let filename = res.headers.filename
            this.blobToFile(res.data, filename)
          })
          .catch(function () {
            console.log('FAILURE!! download file')
          })
      },
      getItemPerPage(val) {
        this.pagination.rowsPerPage = val
      },
      getRequests() {
        let from = this.pagination.page * this.pagination.rowsPerPage - this.pagination.rowsPerPage
        let size = this.pagination.rowsPerPage

        axios
          .get('/api/exportation', {
            params: {
              account: localStorage.getItem('account_id'),
              user: localStorage.getItem('user_id'),
              component: this.component_name,
              from,
              size,
            },
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            this.data = res.data
            this.loading = false
          })
          .catch(function () {
            console.log('FAILURE!! get all requests')
          })
      },

      start() {
        setTimeout(() => {
          this.getRequests()
          this.start()
        }, 5000)
      },
    },
    watch: {
      pagination: {
        handler() {
          this.loading = true
          try {
            this.getRequests()
          } catch (error) {
            console.log('pagination', error)
          }
        },
        deep: true,
      },
    },
  }
</script>
<style></style>
